import useTranslations from "../useTranslations"

export default () => {
  const {
    nav_title_home,
    nav_title_business,
    nav_title_company,
    nav_title_group,
    nav_title_recruit,
    nav_title_contact,
    subnav_business_title_event,
    subnav_business_title_inbound,
    subnav_business_title_artists,
    subnav_business_title_advertising,
    subnav_business_title_clubs,
    subnav_business_title_others,
    subnav_business_description_event,
    subnav_business_description_inbound,
    subnav_business_description_artists,
    subnav_business_description_advertising,
    subnav_business_description_clubs,
    subnav_business_description_others,
    subnav_company_title_overview,
    subnav_company_title_officers,
    subnav_company_title_csr,
    subnav_company_title_sdg,
    subnav_company_title_history,
    subnav_company_title_works,
    subnav_company_description_overview,
    subnav_company_description_officers,
    subnav_company_description_csr,
    subnav_company_description_sdg,
    subnav_company_description_history,
    subnav_company_description_works,
  } = useTranslations()

  return [
    { label: nav_title_home, to: "/" },
    {
      label: nav_title_business,
      to: "/business",
      isSubMenu: true,
      subMenuSlug: "business",
      subMenu: [
        {
          label: subnav_business_title_event,
          description: subnav_business_description_event,
          to: "/event",
        },
        {
          label: subnav_business_title_inbound,
          description: subnav_business_description_inbound,
          to: "/inbound",
        },
        {
          label: subnav_business_title_artists,
          description: subnav_business_description_artists,
          to: "/artists",
        },
        {
          label: subnav_business_title_advertising,
          description: subnav_business_description_advertising,
          to: "/advertising",
        },
        {
          label: subnav_business_title_clubs,
          description: subnav_business_description_clubs,
          to: "/club-production",
        },
        {
          label: subnav_business_title_others,
          description: subnav_business_description_others,
          to: "/other",
        },
      ],
    },
    {
      label: nav_title_company,
      to: "/company",
      isSubMenu: true,
      subMenuSlug: "company",
      subMenu: [
        {
          label: subnav_company_title_overview,
          description: subnav_company_description_overview,
          to: "/overview",
        },
        {
          label: subnav_company_title_officers,
          description: subnav_company_description_officers,
          to: "/officers",
        },
        {
          label: subnav_company_title_csr,
          description: subnav_company_description_csr,
          to: "/csr",
        },
        {
          label: subnav_company_title_sdg,
          description: subnav_company_description_sdg,
          to: "/sdg",
        },
        {
          label: subnav_company_title_history,
          description: subnav_company_description_history,
          to: "/history",
        },
        {
          label: subnav_company_title_works,
          description: subnav_company_description_works,
          to: "/works",
        },
      ],
    },
    { label: nav_title_group, to: "/group" },
    { label: nav_title_recruit, to: "/recruit" },
    { label: nav_title_contact, to: "/contact" },
  ]
}
